import React from 'react';
import { observer } from 'mobx-react';

import { CollectionAsset } from '@kaltura-ott/tvpil-shared';

import { Card, CardBubbleInfo, CardInner, CardTitle } from 'components/presenters';

import CollectionCardContent from './components/CollectionCardContent/CollectionCardContent';
import { useCollectionCard } from './hooks/useCollectionCard/useCollectionCard';

interface Props {
  item: CollectionAsset;
  itemWidth: number;
  imageHeight: number;
  hasNoDirectPlayback?:boolean;
}

function CollectionCard({ item, itemWidth, imageHeight, hasNoDirectPlayback }: Props) {
  const {
    link,
    title,
    isAdult,
    isRecord,
    handleRef,
    ariaLabel,
    assetRating,
    channelName,
    airingObject,
    clickHandler,
    onMouseEnter,
    onMouseLeave,
    contentMarker,
    isLinkAsAsset,
    handleLinkRef,
    isAsPlayAsset,
    isSeriesRecord,
    defaultImageUrl,
    isFutureProgram,
    isDisplayRating,
    handleClickInfo,
    channelHasProgram,
    isDisplayCartIcon,
    backgroundImageUrl,
    seasonEpisodeTitle,
    collectionProgramAsset,
    isDisplayContentMarker,
    isExternalProviderAsset,
  } = useCollectionCard({ item, itemWidth, imageHeight, hasNoDirectPlayback });

  return (
    <Card
      handleLinkRef={handleLinkRef}
      clickHandler={clickHandler}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      link={link!}
      ariaLabel={ariaLabel}
      imageHeight={imageHeight}
      itemWidth={itemWidth}
      isMosaicProgram={false}
    >
      <CardInner
        cardType='collection'
        url={backgroundImageUrl}
        name={title}
        defaultImageUrl={defaultImageUrl}
        handleRef={handleRef}
        handleLinkRef={handleLinkRef}
        isAdult={isAdult}
        isNoDataWithNoLogoImg={false}
        contentOverlay={
          <CollectionCardContent
            airingDate={airingObject}
            isFutureProgram={isFutureProgram}
            isDisplayRating={isDisplayRating}
            assetRating={assetRating!}
            shouldDisplayPlayButton={isAsPlayAsset}
            shouldDisplayCartIcon={isDisplayCartIcon}
            isDisplayContentMarker={isDisplayContentMarker}
            contentMarker={contentMarker}
          />
        }
      />
      <CardBubbleInfo
        isRecord={isRecord}
        isSeriesRecord={isSeriesRecord}
        airingDate={airingObject}
        channelHasProgram={channelHasProgram}
        seasonEpisodeTitle={seasonEpisodeTitle}
        isExternalProviderAsset={isExternalProviderAsset}
        channelName={channelName}
        isAdult={isAdult}
        title={title}
        isMosaicProgram={false}
        handleClickInfo={handleClickInfo}
        collectionProgramAsset={collectionProgramAsset}
        isLinkAsAsset={isLinkAsAsset}
      />
      <CardTitle
        isRecord={isRecord}
        isSeriesRecord={isSeriesRecord}
        seasonEpisodeTitle={seasonEpisodeTitle}
        isAdult={isAdult}
        isStaticInfo
        title={title}
        isMosaicProgram={false}
      />
    </Card>
  );
}

export default observer(CollectionCard);
